module.exports = __webpack_public_path__ + "site/img/64.798b185a.jpg";